import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { igolfMappingRequest } from "API/apiConfig";
import {  AdminUserDetails, AdminUserUpdate } from "API/apiRequest";

const initialState = {
  status: "idle",
  profile_information_data: {},
  profile_information_status: "idle",
  edit_status: "idle",
  isLoggedIn:false,
};
// profile_information section
export const profile_information = createAsyncThunk(
  "/adminUserdetails",
  async ({body,user}) => {
  

    let res =await igolfMappingRequest(AdminUserDetails, body, user)
        .then((res) => res)
        .catch((error) => error);
      // let resData = res?.data;
      let resData = {data:res?.data};
      return resData;
  }
);

export const profile_edit = createAsyncThunk(
  "/adminUserDetailsupdate",
  async ({body,user}) => {
  
    let res =await igolfMappingRequest(AdminUserUpdate, body, user )
        .then((res) => res)
        .catch((error) => error);
        let resData = {data:res?.data};
        return resData;
  }
);


export const ProfileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    removeProfileInfo: (state) => {
      state.profile_information_data = initialState.profile_information_data;
    },
    // logout: (state) => {
    //   // localStorage.removeItem("secretKey")
    //   localStorage.clear()
    // },
  },
  extraReducers: (builder) => {
    builder
      // profile_information section
      .addCase(profile_information.pending, (state) => {
        state.profile_information_status = "loading";
      })
      .addCase(profile_information.fulfilled, (state, { payload }) => {
        state.profile_information_status = "idle";
        state.profile_information_data =  payload?.data;
        if(payload?.data !== undefined){
          localStorage.setItem("profile_data", JSON.stringify(payload?.data));
        }
      })
      .addCase(profile_information.rejected, (state) => {
        state.profile_information_status = "idle";
      })
      // profile_information section

      // profile update
      .addCase(profile_edit.pending, (state) => {
        state.edit_status = "loading"
              })
              .addCase(profile_edit.fulfilled, (state, { payload }) => {
                state.edit_status = 'idle';

                if (payload?.data?.Status === 1) {

                }
              })
              .addCase(profile_edit.rejected, (state, { payload }) => {
                state.edit_status = "idle";
                // if (payload?.status === 200) {
                // }
              });
      // profile update

     
  },
});

export const { removeProfileInfo } = ProfileSlice.actions;

export default ProfileSlice.reducer;
